(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giovese-press-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
    const sections = document.querySelectorAll('.giovese-press-page');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    sections.forEach((section) => {
      const cards = section.querySelectorAll('[data-press-reveal]');
      if (!cards.length) return;

      section.classList.add('giovese-press-page--reveal-ready');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px 18% 0px',
        threshold: 0.06
      });

      cards.forEach((card) => observer.observe(card));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
